
import { ApiProperty } from "@nestjs/swagger";


export class EmpCodeShiftRequest {
    @ApiProperty()
    employeeCodes: string[];

    @ApiProperty()
    shiftCode: string;

    @ApiProperty()
    fromDate: Date

    @ApiProperty()
    toDate: Date

    constructor(employeeCodes: string[], shiftCode: string, fromDate: Date, toDate: Date) {
        this.employeeCodes = employeeCodes,
            this.shiftCode = shiftCode,
            this.fromDate = fromDate,
            this.toDate = toDate
    }
}